import React from 'react';

interface LoadingProps {
  fullScreen?: boolean;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({ 
  fullScreen = true, 
  size = 'medium',
  className = ''
}) => {
  const sizeClasses = {
    small: 'w-4 h-4 border-2',
    medium: 'w-8 h-8 border-4',
    large: 'w-12 h-12 border-4'
  };

  const spinner = (
    <div 
      className={`${sizeClasses[size]} border-primary border-t-transparent rounded-full animate-spin ${className}`}
      role="status"
      aria-label="Loading"
    />
  );

  if (!fullScreen) return spinner;

  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-background"
      role="alert"
      aria-busy="true"
    >
      {spinner}
    </div>
  );
};

export default Loading; 